exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.cls-1[data-v-35863049] {\n    fill: currentColor;\n}\n", ""]);
